

































































































import Vue from "vue";
import { Wyrob } from "@megarax/client/src/resources/plm/Wyrob";

import { Asortyment } from "@megarax/client/src/resources/plm/Asortyment";
import { barcodeFormatter } from "@/shared/barcodeFormatter";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";

export default Vue.extend({
  components: { DefaultRevisionSheet },
  props: {
    value: {
      type: Asortyment,
      required: true,
    },
  },
  methods: {
    barcodeFormatter: barcodeFormatter,
  },
});
